import {Button, Stack, Text, Textarea} from "@mantine/core";
import {useState} from "react";
import type {BatchRow} from "../types";

export function BatchEntryPasteArea(props: {
  languageCode: string;
  type: "vocab" | "character";
  onProcessPaste: (newRows: BatchRow[]) => void;
}) {
  const {languageCode, type, onProcessPaste} = props;
  const [pasteContent, setPasteContent] = useState("");

  const isJapanese = languageCode === "ja";
  const isChinese = languageCode === "zh";

  const getPlaceholder = () => {
    if (isJapanese) {
      if (type === "character") {
        return "猫 | ビン | ねこ | Cat | Radical: 犬\n犬 | ケン | いぬ | Dog";
      }
      return "猫 | neko | Cat | noun\n犬 | inu | Dog | noun";
    }
    if (isChinese) {
      if (type === "character") {
        return "猫 | mao | Cat | Radical: 犬\n犬 | gou | Dog";
      }
      return "猫 | mao | Cat | measure: 只\n犬 | gou | Dog | measure: 只";
    }
    return "cat | neko | Cat\ngood | ii | good";
  };

  const handlePasteAction = () => {
    const lines = pasteContent.split("\n").filter(l => l.trim() !== "");
    const newEntries = lines.map((line): BatchRow => {
      const parts = line.split(/[|\t]/).map(p => p.trim());
      if (parts.length < 2 && line.includes(",")) {
        const csvParts = line.split(",").map(p => p.trim());
        return {
          id: crypto.randomUUID(),
          expression: csvParts[0] || "",
          field1: csvParts[1] || "",
          field2: csvParts[2] || "",
          meaning: csvParts[3] || "",
          auxiliary: csvParts[4] || "",
        };
      }

      return {
        id: crypto.randomUUID(),
        expression: parts[0] || "",
        field1: parts[1] || "",
        field2: parts[2] || "",
        meaning: parts[2] || "",
        auxiliary: parts[3] || "",
      };
    });

    onProcessPaste(newEntries);
    setPasteContent("");
  };

  return (
    <Stack gap="xs" mt="md">
      <Text size="sm" fw={500}>
        Paste text below (One entry per line, separated by | or tab)
      </Text>
      <Textarea
        placeholder={getPlaceholder()}
        minRows={5}
        value={pasteContent}
        onChange={e => setPasteContent(e.currentTarget.value)}
      />
      <Button onClick={handlePasteAction} disabled={!pasteContent.trim()}>
        Process Paste
      </Button>
    </Stack>
  );
}
